// import AOS from 'aos';
// import 'aos/dist/aos.css';

export default defineNuxtPlugin((nuxtApp) => {

  return
  if (process.client) {
    AOS.init();
    nuxtApp.AOS = AOS;
  }
});
